import React from "react";
import "./VisionBoardPage.css";
import PasswordProtection from "./PasswordProtection";

// Fisher-Yates shuffle
function shuffleArray(array) {
  const arr = array.slice();
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

const visionBoardImages = [
  {
    src: "./vision-board-images/2025-06-06 01.49.29.jpg",
    alt: "Maritime Travel",
    title: "Maritime Travel",
  },
  {
    src: "./vision-board-images/2025-06-06 01.41.44.jpg",
    alt: "Japan Travel",
    title: "Japan Travel",
  },
  {
    src: "./vision-board-images/39d80e5004fbccf43a3b871b42026c61.jpg",
    alt: "KPOP Concert",
    title: "KPOP Concert",
  },
  {
    src: "./vision-board-images/2025-06-06 03.31.01.jpg",
    alt: "Cultural Travel",
    title: "Cultural Travel",
  },
  {
    src: "./vision-board-images/cf2a82c8123ab12e0695f306df33786c.jpg",
    alt: "Career Growth",
    title: "Career Growth",
  },
  {
    src: "./vision-board-images/68e81f991759486c11948fe6e6ab28f8.jpg",
    alt: "Health & Wellness",
    title: "Health & Wellness",
  },
  {
    src: "./vision-board-images/946dbaa695da0ecfe844ff6db007c987.jpg",
    alt: "Home Cooking",
    title: "Home Cooking",
  },
  {
    src: "./vision-board-images/c985d83d8305fd0ecbc36c2b3e417eb3.jpg",
    alt: "Learning & Skills",
    title: "Learning & Skills",
  },
  {
    src: "./vision-board-images/2025-06-06 01.41.50.jpg",
    alt: "Lifestyle Goals",
    title: "Lifestyle Goals",
  },
  {
    src: "./vision-board-images/72d2972b663254fe0cd6de41ae8476cd.jpg",
    alt: "Adventure Goals",
    title: "Adventure Goals",
  },
  {
    src: "./vision-board-images/2025-06-06 01.49.19.jpg",
    alt: "Culinary Adventures",
    title: "Culinary Adventures",
  },
  {
    src: "./vision-board-images/f19c04ab3bad1756ac95651c05e6f6aa.jpg",
    alt: "Entertainment & Leisure",
    title: "Entertainment & Leisure",
  },
  {
    src: "./vision-board-images/2025-06-06 19.21.33.jpg",
    alt: "Creative Projects",
    title: "Creative Projects",
  },
  {
    src: "./vision-board-images/2025-06-06 19.18.14.jpg",
    alt: "Home & Space",
    title: "Home & Space",
  },
  {
    src: "./vision-board-images/STD-NR.png",
    alt: "NBA 2K25 Game",
    title: "NBA 2K25 Game",
  },
  {
    src: "./vision-board-images/c8a521c01d7e4d8561d60e99370a55e9.jpg",
    alt: "Amusement Activities",
    title: "Amusement Activities",
  },
];

const VisionBoardContent = () => {
  // Shuffle images on each render
  const shuffledImages = React.useMemo(
    () => shuffleArray(visionBoardImages),
    []
  );

  const renderImageRows = (start, end) => (
    <div style={{ display: "flex", alignItems: "start", gap: "2rem" }}>
      {shuffledImages.slice(start, end).map((img) => (
        <div key={img.title} style={{ flex: 1 }} className="ryujinImage">
          <img
            src={img.src}
            alt={img.alt}
            style={{ width: "100%", cursor: "pointer" }}
            tabIndex={0}
          />
          {/* <div className="image-title">{img.title}</div> */}
        </div>
      ))}
    </div>
  );

  return (
    <div className="container">
      <div style={{ flex: 2.5, paddingTop: "2rem" }}>
        {/* ✧ ✦ */}
        <h1 className="title">Vision Board</h1>
        <p className="description">
          ✦ This is my vision board for the next 2 years. I'm trying to achieve
          these goals by 2027 (December 2026).
        </p>
      </div>
      {/* Desktop grid view */}
      <div className="desktopRyujinImagesList">
        {Array.from({ length: Math.ceil(110 / 4) }, (_, i) =>
          renderImageRows(i * 4, (i + 1) * 4)
        )}
      </div>
      {/* Phone column view */}
      <div className="phoneVisionBoardList">
        {shuffledImages.map((img) => (
          <div key={img.title} className="visionBoardImage">
            <img
              src={img.src}
              alt={img.alt}
              style={{ width: "100%", cursor: "pointer" }}
              tabIndex={0}
              aria-label={`Open ${img.title} in new tab`}
            />
            {/* <div className="image-title">{img.title}</div> */}
          </div>
        ))}
      </div>
    </div>
  );
};

const VisionBoardPage = () => (
  <PasswordProtection>
    <VisionBoardContent />
  </PasswordProtection>
);

export default VisionBoardPage;
